<template>
  <div class="wrapper">
    <div class="loading">
      <div class="loading-spinner"></div>
      <div class="loading-text">正在初始化...</div>
    </div>
  </div>
</template>

<script>
import store from '../store';

export default {
  components:{},
  props:{},
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{
    handleTokenFromUrl() {
      console.log('[Redirect] handleTokenFromUrl 开始执行')
      console.log('[Redirect] this.$route:', this.$route)
      console.log('[Redirect] 当前 localStorage.token:', localStorage.getItem('token'))
      
      const token = this.$route.query.token;
      if (token) {
        console.log('[Redirect] 检测到token，准备保存到localStorage')
        localStorage.setItem('token', token);
        console.log('[Redirect] token已保存，现在localStorage.token:', localStorage.getItem('token'))
        
        store.commit('login', {
          user_name: localStorage.getItem('user_name') || '',
          server_name: localStorage.getItem('server_name') || '',
          server_phone: localStorage.getItem('server_phone') || '',
          server_mobilephone: localStorage.getItem('server_mobilephone') || '',
          server_email: localStorage.getItem('server_email') || '',
          tenant_id: localStorage.getItem('tenant_id') || '',
          tenant_name: localStorage.getItem('tenant_name') || ''
        });
      } else {
        console.log('[Redirect] 没有检测到token')
      }
      
      console.log('[Redirect] 准备跳转到Home')
      this.$router.replace({ name: 'Home' });
    }
  },
  created(){
    console.log('[Redirect] created 钩子执行')
    this.handleTokenFromUrl();
  },
  mounted(){
    console.log('[Redirect] mounted 钩子执行')
    let name = this.$route.params.name;
    let params = this.$route.params.params;
    if (name) {
      this.$router.replace({
        name,
        params
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #4a90d9;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  margin-top: 20px;
  color: #666666;
  font-size: 16px;
}
</style>